import { Flex } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';
import { useNavigate } from 'react-router-dom';
import { useLogError } from 'src/hooks/useLogError';

type ModalErrorProps = {
  /**
   * Pass the error from ErrorBoundary.
   */
  error: Error;
  /**
   * The URL to navigate back to when the error Modal is closed.
   */
  fallbackUrl: string;
};

export const ModalError = ({ error, fallbackUrl }: ModalErrorProps) => {
  const navigate = useNavigate();
  useLogError(error);

  const handleBack = () => {
    navigate(fallbackUrl);
  };

  return (
    <Modal
      width="720px"
      isOpen={true}
      onClose={handleBack}
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        gap={4}
        flexDirection="column"
        alignItems="flex-start"
        width="100%"
        padding={8}
      >
        <FontAwesomeIcon fontSize={32} icon={faExclamationTriangle} />

        <Flex gap={2} flexDirection="column" width="100%">
          <Text textStyle="headingSection">Something went wrong!</Text>
          <Text>
            We could not complete your request: this error has been logged and
            our teams will investigate it soon. Please try again later.{' '}
          </Text>
        </Flex>
        <Flex justifyContent="flex-end" width="100%">
          <Button onClick={handleBack}>Close</Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
